export default class ServiceBanner {
	constructor(config) {
		this.el = config.el || document.querySelectorAll(".service-banner");
		this.message = this.el.querySelector(
			".service-banner__message"
		).textContent;
		this.closeBtn = this.el.querySelector(".service-banner__close");

		this.init();
	}
	init() {
		this.attachEvents();
		this.checkCookie();
	}
	attachEvents() {
		const self = this;
		this.closeBtn.addEventListener("click", function() {
			self.hide();
		});
	}
	checkCookie() {
		const cookieContent = utilities.readCookie("serviceBannerContent");
		if (
			!cookieContent ||
			(cookieContent && cookieContent != encodeURI(this.message))
		) {
			this.show();
		} else {
			this.hide();
		}
	}
	show() {
		this.el.classList.add("service-banner--show");
	}
	hide() {
		this.el.classList.remove("service-banner--show");
		this.el.classList.add("service-banner--hide");
		utilities.createCookie(
			"serviceBannerContent",
			encodeURI(this.message),
			1
		);
	}
}
